import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ACCOUNT_TYPES, DEFAULT_ACCOUNT_TYPE } from '../config/accountTypes';

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', account_type: DEFAULT_ACCOUNT_TYPE });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.name.trim()) return setError('Please enter your name.');
    if (!form.email.trim()) return setError('Please enter your email.');
    if (form.password.length < 8) return setError('Password must be at least 8 characters.');
    setLoading(true);
    try {
      await signup({ ...form, name: form.name.trim(), email: form.email.trim() });
      navigate('/'); // logged in immediately
    } catch (err) {
      setError(err.message || 'Signup failed.');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ position: 'fixed', top: -200, right: -200, width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(20, 80, 74,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ position: 'fixed', bottom: -150, left: -150, width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(224, 165, 38,0.05) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 460, position: 'relative' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="/feebe-mark-pin.png" alt="feebe" width="54" height="54" style={{ display: 'block', margin: '0 auto 14px', objectFit: 'contain' }} />
          <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--white)', marginBottom: 6, letterSpacing: '-0.02em' }}>
            Create your <span style={{ color: 'var(--teal)' }}>fee</span><span style={{ color: 'var(--gold)' }}>be</span> account
          </h1>
          <p style={{ fontSize: 13, color: 'var(--gray-500)' }}>Instant access — start working deals right away</p>
        </div>

        <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 16, padding: '32px', boxShadow: '0 4px 20px rgba(26, 23, 20, 0.06)' }}>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Full name</label>
                <input value={form.name} onChange={set('name')} placeholder="Jane Investor" style={inputStyle}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyle)} onBlur={e => Object.assign(e.target.style, inputStyle)} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Phone <span style={{ color: 'var(--gray-500)', fontWeight: 400 }}>(optional)</span></label>
                <input value={form.phone} onChange={set('phone')} placeholder="512-555-0100" style={inputStyle}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyle)} onBlur={e => Object.assign(e.target.style, inputStyle)} />
              </div>
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Email address</label>
              <input type="email" value={form.email} onChange={set('email')} placeholder="you@example.com" style={inputStyle}
                onFocus={e => Object.assign(e.target.style, inputFocusStyle)} onBlur={e => Object.assign(e.target.style, inputStyle)} />
            </div>

            <div style={{ marginBottom: 18 }}>
              <label style={labelStyle}>Password <span style={{ color: 'var(--gray-500)', fontWeight: 400 }}>(8+ characters)</span></label>
              <input type="password" value={form.password} onChange={set('password')} placeholder="••••••••" style={inputStyle}
                onFocus={e => Object.assign(e.target.style, inputFocusStyle)} onBlur={e => Object.assign(e.target.style, inputStyle)} />
            </div>

            <div style={{ marginBottom: 22 }}>
              <label style={labelStyle}>Account type <span style={{ color: 'var(--gray-500)', fontWeight: 400 }}>(subject to change)</span></label>
              <div style={{ display: 'grid', gap: 8 }}>
                {ACCOUNT_TYPES.map((t) => {
                  const selected = form.account_type === t.value;
                  return (
                    <label key={t.value} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '11px 13px', borderRadius: 9, cursor: 'pointer',
                      border: `1px solid ${selected ? 'var(--teal)' : 'var(--navy-border)'}`, background: selected ? 'var(--teal-dim)' : 'transparent', transition: 'all 0.15s' }}>
                      <input type="radio" name="account_type" value={t.value} checked={selected} onChange={set('account_type')} style={{ marginTop: 2, accentColor: '#14504A' }} />
                      <span>
                        <span style={{ display: 'block', fontSize: 14, fontWeight: 600, color: 'var(--white)' }}>{t.label}</span>
                        <span style={{ display: 'block', fontSize: 12, color: 'var(--gray-500)', marginTop: 2 }}>{t.tagline}</span>
                      </span>
                    </label>
                  );
                })}
              </div>
            </div>

            {error && (
              <div style={{ background: 'rgba(184, 84, 80,0.12)', border: '1px solid rgba(184, 84, 80,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--red)', marginBottom: 18 }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px 20px', background: loading ? 'rgba(20, 80, 74,0.5)' : 'var(--teal)', border: 'none', borderRadius: 10, color: '#FAF7F2', fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', transition: 'all 0.2s', boxShadow: loading ? 'none' : '0 2px 8px rgba(20, 80, 74,0.18)' }}>
              {loading ? 'Creating account...' : 'Create account'}
            </button>
          </form>

          <div style={{ marginTop: 22, paddingTop: 18, borderTop: '1px solid var(--navy-border)', textAlign: 'center', fontSize: 13, color: 'var(--gray-500)' }}>
            Already have an account? <Link to="/login" style={{ color: 'var(--teal)', fontWeight: 600, textDecoration: 'none' }}>Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const labelStyle = { display: 'block', fontSize: 13, fontWeight: 500, color: 'var(--gray-300)', marginBottom: 7 };
const inputStyle = { width: '100%', padding: '11px 14px', background: 'var(--navy)', border: '1px solid var(--navy-border)', borderRadius: 8, color: 'var(--white)', fontSize: 14, outline: 'none', transition: 'border-color 0.15s', boxSizing: 'border-box' };
const inputFocusStyle = { ...inputStyle, borderColor: 'var(--teal)' };
